"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_accessories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "86b40419-30aa-40ec-967b-24122a9964a6",
    x1: 32.47,
    y1: 103.33,
    x2: 59.04,
    y2: 129.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7552e260-592f-4d31-a677-b9f78765e93c",
    x1: 150.87,
    y1: 105.4,
    x2: 179.72,
    y2: 134.25,
    xlinkHref: "#86b40419-30aa-40ec-967b-24122a9964a6"
  })), /*#__PURE__*/React.createElement("title", null, "accessories-hi"), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "f237ce3f-4bb4-4395-ad89-5d37b0dae8e4",
    "data-name": "accessories-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a52c38a0-e5e7-4d2e-aea2-a3e2949367db",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1b3f94ed-69d6-4b9a-a18a-479725e567e1",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b5072755-bf5d-4fcb-a65d-9f7045422d12",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "542d7499-5510-4db8-9ace-424419851301",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "765b04d5-5a7b-4d48-809c-76a9449ef9e5",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7b5a9ec0-ea80-4a53-8849-c38b6d975119",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f8f09a80-383f-4b0b-a3b0-9fd02b1d23fa",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b71b3221-2e22-4c2b-a084-1d952cc3a561",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eb038f04-e77b-4831-a4e6-458760a56fd5",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2307ed78-2d52-4a3b-bc13-c6eb1786fd7d",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "92f3b446-f729-4c4c-9ca5-53df20c8b532",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aba14aff-d7bf-4895-bc44-b135a178e678",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dc463ddc-008a-4ced-8fb6-3b49547a2399",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5d5cdf62-4fcd-4426-8132-923a572dcf20",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fc6b6909-120d-4a03-963b-bf45c115f3fe",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "36b05c5d-abb4-4c05-8c99-53daea61fe80",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16bcd4d8-63c6-465f-a736-810a3e6e3195",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "94102c76-e23a-40df-b26c-9e7377e21af1",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "071161b5-ed06-4e55-a87c-fd692511907d",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a446e710-bd01-41fd-bbe0-5e301f5f3d40",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2c37ef5e-b6e2-4207-8170-ee972b81790d",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a9980fa4-39d0-4e2f-916e-4986069f343a",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ec719323-5431-4f12-9982-e9477f1ea2fa",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d181266e-471d-4554-a42f-02a4dee682f5",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aed7c11b-6a39-4a58-9426-c60f3be58350",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "86914f05-d0de-4746-9a28-125646911181",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "086256f3-fab5-4426-acf3-4c14d9798520",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.38,96H47.85a0,0,0,0,1,0,0v72a0,0,0,0,1,0,0H37.38a16,16,0,0,1-16-16V112A16,16,0,0,1,37.38,96Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.38,151.93h0V112.1h0a5.51,5.51,0,0,0-5.5,5.55v28.73A5.51,5.51,0,0,0,21.38,151.93Z",
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.75,96h4.14a4,4,0,0,1,4,4v64a4,4,0,0,1-4,4H47.75a0,0,0,0,1,0,0V96A0,0,0,0,1,47.75,96Z",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.38,150v-.07a5.51,5.51,0,0,1-5.5-5.55v2a5.51,5.51,0,0,0,5.5,5.55V150Z",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.7,96h10.57a0,0,0,0,1,0,0v72.07a0,0,0,0,1,0,0H159.7a16,16,0,0,1-16-16V112A16,16,0,0,1,159.7,96Z",
    transform: "translate(313.96 264.07) rotate(-180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.27,152h0V112.1h0a5.55,5.55,0,0,1,5.55,5.55v28.8A5.55,5.55,0,0,1,170.27,152Z",
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.73,96h4.07a4,4,0,0,1,4,4v64.07a4,4,0,0,1-4,4h-4.07a0,0,0,0,1,0,0V96A0,0,0,0,1,135.73,96Z",
    transform: "translate(279.53 264.07) rotate(-180)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.27,152v.07a16,16,0,0,1-16,16H139.73a4,4,0,0,1-4-4v-2a4,4,0,0,0,4,4h14.53a16,16,0,0,0,16-16V150",
    opacity: 0.06,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.89 141.06 32.3 125.91 39.77 96.02 47.89 96 47.89 141.06",
    opacity: 0.2,
    fill: "url(#86b40419-30aa-40ec-967b-24122a9964a6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.29,143.68l-17-16.58,6.06-30.22h0a16.68,16.68,0,0,1,11,15.76Z",
    opacity: 0.2,
    fill: "url(#7552e260-592f-4d31-a677-b9f78765e93c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.89,128a4,4,0,0,1-4-4V88.15A56.12,56.12,0,0,0,95.83,32.09,55.31,55.31,0,0,0,55.61,49,56.9,56.9,0,0,0,39.78,88.15V124a4,4,0,1,1-8,0V88.15A65,65,0,0,1,49.85,43.48a63.24,63.24,0,0,1,46-19.39,64.13,64.13,0,0,1,64.06,64.06V124A4,4,0,0,1,155.89,128Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.83,24.09a63.24,63.24,0,0,0-46,19.39l-.5.53a4,4,0,0,0,.1,5.56l3,3c1-1.23,2-2.43,3.14-3.57A55.31,55.31,0,0,1,95.83,32.09a56,56,0,0,1,43.4,20.62l3-3a4,4,0,0,0,.11-5.53A63.87,63.87,0,0,0,95.83,24.09Z",
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24,52.71a55.8,55.8,0,0,1,12.65,35.44v-2a55.78,55.78,0,0,0-11.78-34.34Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.58,51.71a56.9,56.9,0,0,0-11.8,34.43v2A56.91,56.91,0,0,1,52.46,52.59Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.11,51.81A56,56,0,0,0,95.83,30.09,55.35,55.35,0,0,0,51.58,51.71l.89.87Q54,50.74,55.61,49A55.31,55.31,0,0,1,95.83,32.09a56,56,0,0,1,43.4,20.62Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.38,151.93V152a16,16,0,0,0,16,16h14.5a4,4,0,0,0,4-4v-2a4,4,0,0,1-4,4H37.38a16,16,0,0,1-16-16v1.93Z",
    opacity: 0.06,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.27,150.07V150a5.55,5.55,0,0,0,5.55-5.55v2a5.55,5.55,0,0,1-5.55,5.55v-1.93Z",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  })))))))))))))))))))))))))))))));
}

var _default = ic_accessories;
exports.default = _default;